import config from "../build/config"
const domain = window.location.protocol + '//' + window.location.host + '/' + config.BASE_PATH

const showServerSetting = {
  ShowInfo: 0,
  ErrorLogin: 1,
  ErrorConnect: 2
}

const invoiceTypeEnum = {
  MONTHLY: 0,
  QUATERLY: 1
}

const invoiceActionSendEmailAndNotification = {
  SEND_EMAIL: 0,
  NOTIFICATION: 1
}

const sendInvoiceTypeEnum = {
  PERIODIC: 1,
  REMINDER: 2
}

const ApartmentTypeTabs = {
  APARTMENT_TYPE: 0,
  APARTMENT_GROUP: 1,
  PRODUCT_IN_APARTMENT_TYPE: 2
}

const defaultExtraInfoList = {
  APARTMENT_EXTRA_INFO: 'APARTMENT_EXTRA_INFO',
  USER_EXTRA_INFO: 'USER_EXTRA_INFO'
}

const ApartmentImgType = {
  APARTMENT_IMG: 1,
  APARTMENT_MAP_IMG: 2,
  APARTMENT_CONTRACT_IMG: 3
}

const ApartmentBookingStatus = {
  WAITING_CHECK_IN: 1,
  CANCEL: 2,
  CHECKED_IN: 3
}

const ApartmentReceiptEnum = {
  INVOICE_REVENUE: 1,
  REVENUE_OF_ROOM_MONEY: 2
}

const ApartmentResidentApprovalEnum = {
  UNAPPROVED: 1,
  APPROVED: 2,
  CANCELED: 3
}

const UserRegisterExportInvoiceStatusEnum = {
  INACTIVATE: 1,
  ACTIVATED: 2,
  DELETED: 3
}

const MaintenanceApprovalEnum = {
  WAITING_APPROVAL: 1,
  APPROVED: 2,
  UNAPPROVED: 3
}

const MaintenanceStatusEnum = {
  MAINTENANCE_TRACKING: 1,
  MAINTENANCE_PLANNING: 2,
  MAINTENANCE_IN_PROCESSING: 3,
  MAINTENANCE_FINISHED: 4,
  MAINTENANCE_CANCELED: 5
}

const ActionHistoryEnum = {
  CREATE: 1,
  UPDATE: 2,
  DELETE: 3,
  COMMENT: 4,
  SEND_EMAIL: 5,
  SEND_NOTIFICATION: 6
}

const MaintenanceTypeEnum = {
  MAINTENANCE: 1,
  CALIBRATION: 2,
  INCIDENT: 3
}

const AssetStatusEnum = {
  WORKING: 1,
  DAMAGED_PENDING: 2,
  WAITING_FOR_LIQUIDATION: 3,
  LIQUIDATED: 4
}

const AssetActivityPlanEnum = {
  CREATE: 1,
  COMPLETE: 2,
  CANCEL: 3,
  IN_PROCESSING: 4,
  REMOVE: 5
}

const SMTPServiceEnum = {
  BQL_SMTP: 0,
  CSKH_SMTP: 1
}

const ApartmentHistoryModuleName = {
  PERM_MODULE_APARTMENT: 'perm_module_apartment',
  PERM_MODULE_APARTMENT_RESIDENT: 'perm_module_apartment_resident'
}

const ReceiptReceiveInfoTypeEnum = {
  OWNER: 1,
  TENANT: 2,
  OTHER: 3
}

const ServiceIdEnum = {
  ELECTRIC: 1,
  WATER: 2,
  MANAGEMENT: 7
}

const InvoiceStatusEnum = {
  ACTIVATED: 1,
  OBSOLETE: 2,
  DELETED: 3
}

export default {
  domain,
  showServerSetting,
  invoiceTypeEnum,
  invoiceActionSendEmailAndNotification,
  sendInvoiceTypeEnum,
  ApartmentTypeTabs,
  defaultExtraInfoList,
  ApartmentImgType,
  ApartmentBookingStatus,
  ApartmentReceiptEnum,
  ApartmentResidentApprovalEnum,
  UserRegisterExportInvoiceStatusEnum,
  MaintenanceApprovalEnum,
  MaintenanceStatusEnum,
  ActionHistoryEnum,
  MaintenanceTypeEnum,
  AssetStatusEnum,
  AssetActivityPlanEnum,
  SMTPServiceEnum,
  ApartmentHistoryModuleName,
  ReceiptReceiveInfoTypeEnum,
  ServiceIdEnum,
  InvoiceStatusEnum
}


//////////////////
// WEBPACK FOOTER
// ./enum/enum.js
// module id = gr96
// module chunks = 0